import { api } from "../core/api";

export default {
    getUsers(params) {
        return api.get("/ApplicationUser/GetAll", { params: params });
    },
    getUser(param) {
        return api.get("/ApplicationUser/Get", { params: param });
    },
    addUser(user) {
        return api.post("/ApplicationUser/Add", user);
    },
    updateUser(user) {
        return api.patch("/ApplicationUser/Update", user);
    },
    toogleActivate(id) {
        return api.put(`/ApplicationUser/ToogleActivate?id=${id}`);
    },
    deleteUser(id) {
        return api.delete(`/ApplicationUser/Delete?id=${id}`);
    },
    getResumenUserByRole() {
        return api.get('/ApplicationUser/GetResumenUsersResumenByRole');
    },
};
